// extracted by mini-css-extract-plugin
module.exports = {"size-guide":"size-guide_size-guide__4L7AW","table":"size-guide_table__k_Dz4","video":"size-guide_video__Jaz_G","body":"size-guide_body__mMgEW"};